import { useRootStore } from "store";
import EmailSubmitForm from "views/login/components/EmailSubmitForm";

export default function GenerateOnetimeLogin() {
  const { generateOnetimeLogin, hasSent } = useRootStore(
    (state) => state.generateOnetimeLogin
  );

  const sendLink = (email: string) => {
    generateOnetimeLogin(email);
  };

  return (
    <>
      {hasSent ? (
        <div className="box">
          <h1>Engångslänk för inloggning</h1>
          <hr className="header-border" />
          <p>
            En länk har skickats till din e-post. Vänligen följ länken för att
            logga in på MittKontor.
          </p>
          <p>
            Observera att länken bara är giltig i 24h.
            <br />
          </p>
          <p>Får du inget mail?</p>
          <ul>
            <li>Titta i skräpposten</li>
            <li>Lägg till noreply@ludvig.se som betrodd avsändare</li>
            <li>
              Fel e-postadress?{" "}
              <a href="/generate-onetime-login">Använd en annan e-postadress</a>
            </li>
            <li>
              Kanske har du inte aktiverat ditt konto? Kontakta då din rådgivare
              via mail eller på tel: 0771-27 27 27.
            </li>
          </ul>
        </div>
      ) : (
        <div className="box">
          <h1>Skapa engångslänk för inloggning</h1>
          <hr className="header-border" />
          <p>Ange din e-postadress i fältet så skickar vi en länk.</p>
          <EmailSubmitForm triggerAction={sendLink} />
        </div>
      )}
    </>
  );
}
